import { jsx as _jsx } from "react/jsx-runtime";
import { scale130, scale150, scale160, scale180 } from '@xingternal/tokens';
import { SkeletonPillShape } from '..';
export const SkeletonInputBar = ({ className, size = 'medium', ...props }) => {
    const sizes = {
        small: scale130,
        medium: scale150,
        large: scale160,
        xlarge: scale180,
    };
    return (_jsx(SkeletonPillShape, { className: className, "data-xds": "SkeletonPillShape", height: sizes[size], ...props }));
};
SkeletonInputBar.displayName = 'SkeletonInputBar';
//# sourceMappingURL=skeleton-input-bar.js.map